export enum CompensationType {
  HOURLY = 'hourly',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export enum CommitmentType {
  ANY = 'any',
  FULL_TIME = 'full-time',
  PART_TIME = 'part-time',
  CONTRACT = 'contract',
  TEMPORARY = 'temporary',
  VOLUNTEER = 'volunteer',
  SEASONAL = 'seasonal',
  INTERNSHIP = 'internship',
}

export const COMMITMENT_TYPE_OPTIONS = [
  { label: 'Full-Time', value: CommitmentType.FULL_TIME },
  { label: 'Part-Time', value: CommitmentType.PART_TIME },
  { label: 'Contract', value: CommitmentType.CONTRACT },
  { label: 'Temporary', value: CommitmentType.TEMPORARY },
  { label: 'Volunteer', value: CommitmentType.VOLUNTEER },
  { label: 'Seasonal', value: CommitmentType.SEASONAL },
  { label: 'Internship', value: CommitmentType.INTERNSHIP },
];

export const COMPENSATION_TYPE_OPTIONS = [
  { label: 'Hour', value: CompensationType.HOURLY },
  { label: 'Week', value: CompensationType.WEEKLY },
  { label: 'Month', value: CompensationType.MONTHLY },
  { label: 'Year', value: CompensationType.YEARLY },
];